import axios from 'axios'
import { CENTER, SYSTEM_CENTER, SYSTEM_CENTER_APPOINTMENT_CONFIG } from '@/assets/scripts/api'
import Cookies from 'js-cookie'

const state = {
  wxAppId: '',
  position: {},
  cityList: [],
  sysCenter: {},
  centerDisease: {}
}

const mutations = {
  setCityList (state, data) {
    state.cityList = data.sort(function (a, b) {
      let spellA = a.spell || 'z'
      let spellB = b.spell || 'z'
      return ((spellA.charCodeAt() < spellB.charCodeAt()) ? -1 : ((spellA.charCodeAt() > spellB.charCodeAt()) ? 1 : 0))
    })
  },
  setSysCenter (state, data) {
    state.sysCenter = data
  },
  setCenterDisease (state, data) {
    state.centerDisease = data
  },
  setAppointmentInfo (state, data) {
    state.sysCenter = Object.assign({}, state.sysCenter, data)
  },
  setWxAppId (state, data) {
    state.wxAppId = data
  },
  setPosition (state, data) {
    state.position = data
  }
}

const getters = {
  /**
   * getter方法,判断当前用户是否已选择体检中心
   * @param state
   * @returns {{Boolean}|state.sysCenter|*}
   */
  hasSysCenter (state) {
    return !!(state.sysCenter && state.sysCenter.id && state.sysCenter.name)
  }
}
const actions = {
  loadSysCenterList: async function ({commit, state, rootState}) {
    if (state.cityList.length === 0) {
      let {data} = await axios.get(CENTER, {params: {_BIZCODE: '0003', sid: rootState.sid}})
      let cityList, children
      cityList = []
      if (data && data.cities) {
        for (let item of data.cities) {
          children = item.children
          cityList = [...cityList, ...children]
        }
      }
      console.log(cityList)
      commit('setCityList', cityList)
    }
  },
  loadSysCenterAppointmentInfo: async function ({commit, state, rootState}, packageId) {
    let detail = {}
    let {data} = await axios.get(SYSTEM_CENTER_APPOINTMENT_CONFIG, {
      params: {
        '_BIZCODE': '0001',
        'sysCenterId': state.sysCenter.id,
        'packageId': packageId
      }
    })
    // 配置
    detail.individuationOpt = data.individuationOpt
    detail.projectSelectOpt = data.projectSelectOpt
    detail.receiveOnline = data.receiveOnline
    detail.expertUrl = data.expertUrl
    detail.honorUrl = data.honorUrl
    detail.disclaimer = data.disclaimer
    //新增配置

    detail.personalNotInvoiceNote = data.personalNotInvoiceNote //个检不配置发票
    detail.groupShowPrice = data.groupShowPrice === 1 //团检显示价格
    detail.showPackagePrice = data.showPackagePrice === 1 //个检套餐显示价格
    detail.personalProvideInvoice = data.personalProvideInvoice === 1 //个检发票
    detail.groupProvideInvoice = data.groupProvideInvoice === 1 //团检发票
    //邮费
    detail.deliverInfo = {}
    detail.deliverInfo.price = parseFloat(data.mailCost, 10)
    detail.deliverInfo.name = data.mailExpress
    if (typeof data.paymentMethodCodes === 'string' || typeof data.hosPaymentMethodCodes === 'string') {
      detail.paymentMethodCodes = {}
      console.log(Cookies.get('51jk._initSid') === '00-0')
      if (Cookies.get('51jk._initSid') === '00-0') {
        detail.paymentMethodCodes.online = data.paymentMethodCodes.indexOf('online') > -1
        detail.paymentMethodCodes.onhospital = data.paymentMethodCodes.indexOf('onhospital') > -1
      } else {
        detail.paymentMethodCodes.online = data.hosPaymentMethodCodes.indexOf('online') > -1
        detail.paymentMethodCodes.onhospital = data.hosPaymentMethodCodes.indexOf('onhospital') > -1
      }
    }
    console.log(  detail.paymentMethodCodes.online,    detail.paymentMethodCodes.onhospital )
    //预约审核限制
    detail.verify = {}
    detail.verify.on = data.verifyOn + ''
    detail.verify.type = data.verifyType + ''
    detail.centerConfigMenu = []
    if (data.healthFlag === 1 || data.healthFlag === '1') detail.centerConfigMenu.push('healthFlag')
    if (data.onlineFlag === 1 || data.onlineFlag === '1') detail.centerConfigMenu.push('onlineFlag')
    if (data.columnFlag === 1 || data.columnFlag === '1') detail.centerConfigMenu.push('columnFlag')
    commit('setAppointmentInfo', detail)
  },
  loadSysCenterDetail: async function ({commit, state, dispatch, rootState}, sysCenterId) {
    if (sysCenterId === '00-0') {
      return ''
    } else if (state.sysCenter.id !== sysCenterId || !state.sysCenter.name) {
      let backup = state.sysCenter
      commit('setSysCenter', {id: sysCenterId})
      let {data} = await axios.get(SYSTEM_CENTER, {
        params: {
          '_BIZCODE': '0002',
          'sysCenterId': sysCenterId
        }
      })
      if (data && data.id && data.name) {
        commit('setSysCenter', data)
        dispatch('loadSysCenterAppointmentInfo')
      } else {
        commit('setSysCenter', backup)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
